window.$ = window.jQuery = require( "jquery" )

window._ = require( "lodash" )

require( "./common/header" )
require( "./common/search" )
require( "./common/carousel" )
require( "./common/modal" )
require( "./common/user_portal" )
require( "./common/features" )
require( "./common/notice" )
require( "./common/global" )
require( "./common/banner" )


$( "input[type=tel]" ).on( 'keyup', function () {
    $( this ).val( $( this ).val().replace( /^(\d{3})(\d{3})(\d+)$/, "($1) $2 - $3" ) )
} )
